export default "__VITE_ASSET__DiA946UC__"